import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Tabs } from 'antd';
import VerificationCode from '../../Login/VerificationCode';
import Password from '../../Login/Password';
import ForgetPassword from '../../Login/ForgetPassword';
import s from '../../Login/style.m.less';
import InformationModal from './InformationModal';
import withRouter from '@/components/withRouter';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
@inject('store')
@observer
class Qhb extends Component {
    state = {
        loading: true
    };
    async componentDidMount() {
        const {
            store: { login }
        } = this.props;

        login.setQhbMode(this.props.searchParams.get('id') ? 'region' : 'city');
        login.setQegionId(this.props.searchParams.get('id') || '');

        const isLogin = await login.checkLogin();
        if (isLogin) {
            return login.loginCallback(null,'competition');
        }
        this.setState({
            loading: false
        });
    }
    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };

    render() {
        const {
            store: { login }
        } = this.props;

        return this.state.loading ?
        <GrtLoading /> :
        (
            login.qhbMode === 'city' ? (
            <div className={s.competition_app}>
                <div style={{ height: 'calc(100vh - 110px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '1200px' }}>
                        <div style={{ position: 'relative' }}>
                            <div className={s.qhb_logo}></div>
                        </div>
                        <div className={s.login_logo}></div>
                        <div className={s.competition_logo}></div>
                        <div className={s.competition_content}>
                            <Card hoverable>
                                {login.mode === 'login' ? (
                                    <Tabs
                                        onChange={this.onChange}
                                        activeKey={login.activeKey}
                                        items={[
                                            {
                                                key: 'code',
                                                label: '验证码登录',
                                                children: <VerificationCode type="competition" />
                                            },
                                            {
                                                key: 'password',
                                                label: '密码登录',
                                                children: <Password type="competition" />
                                            }
                                        ]}
                                    />
                                ) : (
                                    <ForgetPassword type="competition" />
                                )}
                            </Card>
                        </div>
                        <div className={s.competition_info}>
                            <div style={{ position: 'absolute', top: '-30px' }}>
                                <div className={s.info_text}>
                                    <span className={s.flag}></span>
                                    <span style={{ marginLeft: '-25px' }}>活动说明</span>
                                </div>
                                <p>
                                    1.参展对象
                                    <br />
                                    2023年1月1日以后参加工作的全市幼儿园、中小学新任教师。
                                </p>
                                <p>
                                    2.名额分配
                                    <br />
                                    按照各区新任教师总数，依据“全市统筹、比例适当、倾斜远郊区”的原则，确定各区参展教师名额。
                                </p>
                                <p>
                                    3.签署同意书及诚信书
                                    <br />
                                    参加展示活动的教师需在活动前在线签署相关作品的网络传播权转让同意书，以及原创作品诚信书。
                                </p>
                                <div
                                    className={s.info_link}
                                    onClick={() => {
                                        window.open('https://www.bjteachers.cn/h/home/gyjz2024/', '_blank');
                                    }}
                                >
                                    公益讲座 <span className={s.link}></span>
                                </div>
                            </div>
                            <div className={s.logo_2024}></div>
                        </div>
                    </div>
                </div>
                <div className={s.footer}>
                    <div
                        style={{
                            width: '1200px',
                            height: '110px',
                            margin: '0 auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div className={s.footer_logo}></div>
                        <div className={s.footer_text}>
                            <div style={{ marginBottom: '8px' }}>
                                主办单位：北京教育学院 <span style={{ marginLeft: '30px', display: 'inline-block' }}>北京市特级教师协会</span>
                                <span style={{ marginLeft: '30px', display: 'inline-block' }}> 北京市学前儿童保教工作者协会</span>
                            </div>
                            <div>技术支持：北京国人通教育科技有限公司</div>
                        </div>
                    </div>
                </div>
                <InformationModal />
            </div>
            ) : (
                <div className={`${s.competition_app} ${s.region_app}`}>
                    <div style={{ height: 'calc(100vh - 50px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ width: '1200px' }}>
                            <div className={s.region_logo}></div>

                            <div className={s.right}>
                                <div style={{ minWidth: '200px', height: '22px' }}></div>
                            </div>

                            <div className={s.region_text}></div>
                            <div className={s.competition_content}>
                                <Card hoverable>
                                    {login.mode === 'login' ? (
                                        <Tabs
                                            onChange={this.onChange}
                                            activeKey={login.activeKey}
                                            items={[
                                                {
                                                    key: 'code',
                                                    label: '验证码登录',
                                                    children: <VerificationCode type="competition" />
                                                },
                                                {
                                                    key: 'password',
                                                    label: '密码登录',
                                                    children: <Password type="competition" />
                                                }
                                            ]}
                                        />
                                    ) : (
                                        <ForgetPassword type="competition" />
                                    )}
                                </Card>
                            </div>
                        </div>
                    </div>
                    <div className={s.footer} style={{ height: '50px' }}>
                        <div
                            style={{
                                width: '1200px',
                                height: '50px',
                                margin: '0 auto',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <div className={s.footer_text}>
                                <div>技术支持：北京国人通教育科技有限公司</div>
                            </div>
                        </div>
                    </div>
                    <InformationModal />
                </div>
            )
        );
    }
}

export default withRouter(Qhb);
